import React, {FC, useEffect, useRef} from 'react';

const TURNSTILE_SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY || '0x4AAAAAAD-X9HIK323_X5pf';
const TURNSTILE_ACTION = 'souhait-form';

declare global {
  interface Window {
    turnstile?: {
      render: (
        target: HTMLElement,
        options: {
          sitekey: string;
          callback: (token: string) => void;
          'expired-callback': () => void;
          'error-callback': () => void;
          action: string;
          theme: 'light';
        }
      ) => string;
      remove: (widgetId: string) => void;
    };
  }
}

export const TurnstileWidget: FC<{onToken: (token: string) => void}> = ({
  onToken,
}) => {
  const container = useRef<HTMLDivElement | null>(null);
  const production = process.env.NODE_ENV === 'production';
  useEffect(() => {
    if (!production) {
      onToken('local-development');
      return () => onToken('');
    }
    let widgetId = '';
    const render = () => {
      if (!container.current || !window.turnstile || widgetId) return;
      widgetId = window.turnstile.render(container.current, {
        sitekey: TURNSTILE_SITE_KEY,
        callback: onToken,
        'expired-callback': () => onToken(''),
        'error-callback': () => onToken(''),
        action: TURNSTILE_ACTION,
        theme: 'light',
      });
    };
    const existing = document.querySelector<HTMLScriptElement>(
      'script[data-souhait-turnstile]'
    );
    if (existing) {
      if (window.turnstile) render();
      else existing.addEventListener('load', render, {once: true});
    } else {
      const script = document.createElement('script');
      script.src =
        'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      script.async = true;
      script.defer = true;
      script.dataset.souhaitTurnstile = 'true';
      script.addEventListener('load', render, {once: true});
      document.head.appendChild(script);
    }
    return () => {
      if (widgetId && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [onToken, production]);
  return (
    <div className="turnstile-slot" ref={container}>
      {!production && (
        <span className="turnstile-slot__local">Contrôle anti-abus désactivé en local</span>
      )}
    </div>
  );
};
